
    var riot = require('riot')
    
import Cart from './Cart'
import {types} from '@riot/store'
riot.tag2('card-product', '<div class="card__cart-head"> <div class="card__cart__img"> <div class="img" riot-style="{setBg(opts.img)};"></div> </div> <div class="card__cart__name"> <dl> <dt>{opts.category}</dt> <dd><a href="{opts.href}"> <p if="{chkNull(opts.name)}">{opts.name}</p> <p if="{chkNull(opts.spec1)}">{opts.spec1}</p> <p if="{chkNull(opts.spec2)}">{opts.spec2}</p></a></dd> </dl> </div> </div> <div class="card__cart-bottom"> <div class="card__cart-price"> <div class="cmn__price"> <dl> <dt>価格</dt> <dd><em>{opts.price}</em>円</dd> </dl> </div> <div class="cmn__select-group js-tile-box" ref="selects" if="{!isDisable()}" riot-style="{setHeight(minHeight)};"> <yield></yield> </div> <div class="cmn__select-group" ref="selects" if="{isDisable()}" riot-style="{setHeight(minHeight)};"> <p class="notes-danger">在庫切れ</p> </div> </div> <div class="card__cart-btn"> <div class="cmn__cart {isDisable()}" if="{!isDisable()}"><a onclick="{addCart}" data-code="{opts.code}"><span>カートに入れる</span></a></div> <div class="cmn__cart {isDisable()}" if="{isDisable()}"><a href="javascript:void(0);" data-code="{opts.code}"><span>在庫切れ</span></a></div> </div> </div>', '', '', function(opts) {

    const self = this
    const cartClass = new Cart()

    self.code = self.opts.code
    self.minHeight = 0
    self.addCart = cartClass.addCart

    self.on('mount', () => {
      self.setTile()
    })

    $(window).on('load resize orientationchange', function(){
      self.setTile()
    })

    opts.$store.on('onchange', () => {
      self.minHeight = opts.$store.getters().tiles.max()
      self.update()
    })

    this.setTile = function() {
      let h = []
      $(".js-tile-box").each(function(){
        h.push( $(this).outerHeight() )
      })
      opts.$actions[types.SET_TILE](h)
    }.bind(this)

    this.setHeight = function(data) {
      return `
        min-height: ${data}px;
      `
    }.bind(this)

    this.isDisable = function(){
      if( self.opts.disabled == "disabled" ) {
        return "is-disabled"
      } else {
        return null
      }
    }.bind(this)

    this.chkNull = function(text){
      switch (text) {
        case '':
        case false:
        case null:
          return false
        default:
          return true
      }
    }.bind(this)

    this.setBg = function(img) {
      return `background-image: url(${img})`
    }.bind(this)
});
    
  


// WEBPACK FOOTER //
// ./_src/riot/product/card-product.tag